import styled from 'styled-components';

const NoResultsStyle = styled.div`
  text-align: center;
  width: 100%;
  padding: 24px 0;

  p {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
`;

const NoResultsStyleSm = styled.div`
  text-align: center;
  width: 100%;
  padding: 20px 0;

  p {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
`;

export {
  NoResultsStyleSm
};

export default NoResultsStyle;
